import { Base } from "ui/Scripts/source/framework/base";
import { FileAttachment, IFileAttachment } from "ui/Scripts/source/models/common/fileAttachment";

export interface IFrontPageImages {
    defaultImage: string;
    images: IFileAttachment[];
    imageChangeInterval: number;
}

export class FrontPageImages implements IFrontPageImages {
    defaultImage: string;
    images: FileAttachment[];
    imageChangeInterval: number;

    constructor();
    constructor(obj: IFrontPageImages);
    constructor(obj?: any) {
        this.defaultImage = obj && obj.defaultImage || "";
        this.imageChangeInterval = obj && obj.imageChangeInterval || 0;
        this.images = Base.getTypedArray(obj ? obj.images : null, FileAttachment);
    }
}